import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noDataOrder.png'


const _withScopeId = n => (_pushScopeId("data-v-540f0f6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "orderBox"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "high" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "org" }
const _hoisted_6 = { class: "end" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 2,
  class: "noDataOrder"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "paging" }

import { reactive, computed } from "vue";
import { queryRewardsLists } from "@/api/userCenter";
import i18n from "@/lang";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemRewards',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => store.state.isMobile);
const appLanguage = computed(() => store.state.appLanguage);
const scoreMation = reactive({
  list: [],
  total: 0,
});
const pageInfo = reactive({
  pageIndex: 1,
  pageSize: 10,
});
const handlerPage = () => {
  queryRewardsLists({
    ...pageInfo,
  }).then((res) => {
    console.log(res.data);
    scoreMation.list = res.data.records;
    scoreMation.total = res.data.total;
  });
};
handlerPage();

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['orderList', { mobileSize: _unref(isMobile) }])
  }, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          title: _ctx.$t('user_center.integral'),
          toPath: "/userCenter"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (scoreMation.list.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_unref(isMobile))
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: scoreMation.list,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('user_center.rewards_service_name'),
                    align: "center",
                    "show-overflow-tooltip": "",
                    width: "250"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`user_center.rewards_${scope.row.tradeType}`, {
                supplyInfo: scope.row.supplyInfo,
                content: scope.row.content,
              })), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('user_center.rewards_service_time'),
                    align: "center",
                    prop: "createTime"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('user_center.rewards_service_amount'),
                    align: "center",
                    "show-overflow-tooltip": "",
                    width: "160"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString((scope.row.direction ? "+" : "-") + scope.row.subAmount), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoreMation.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "cardBox",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: "title",
                        textContent: _toDisplayString(
                _ctx.$t(`user_center.rewards_${item.tradeType}`, {
                  supplyInfo: item.supplyInfo,
                  content: item.content,
                })
              )
                      }, null, 8, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, _toDisplayString((item.direction ? "+" : "-") + item.subAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "l",
                        textContent: _toDisplayString(item.createTime)
                      }, null, 8, _hoisted_7)
                    ])
                  ]))
                }), 128))
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("user_center.not_rewards_info")), 1)
        ])),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        onSizeChange: handlerPage,
        onCurrentChange: handlerPage,
        "current-page": pageInfo.pageIndex,
        "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo.pageIndex) = $event)),
        "hide-on-single-page": "",
        "page-size": pageInfo.pageSize,
        "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo.pageSize) = $event)),
        total: scoreMation.total
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ], 2))
}
}

})